import './index.scss';
import React, { useState, useEffect } from 'react';
import { detail } from '../../services/saas/notifyUser';
import { getBooleanValue } from '../../utils';
import { NavBar } from 'antd-mobile';

function NotifyInfo(props) {
  const [info, setInfo] = useState({});

  const getNotifyInfo = async () => {
    const {
      match: {
        params: { id },
      },
    } = props;
    const respDetail = await detail({ id, source: 'read' });
    if (respDetail.success) {
      setInfo(respDetail.data);
    }
  };

  useEffect(() => {
    getNotifyInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  return (
    <div className={`notifyInfo ${getBooleanValue('IS_IMMERSE', false) ? 'immerse' : ''}`}>
      <NavBar
        mode="light"
        icon={<div className="back"></div>}
        onLeftClick={() => window.history.go(-1)}
      >
        <span>
          【{info.sourceAppName}】{info.actionName}
        </span>
      </NavBar>
      <div className="content">
        <div className="info-content">{info.content}</div>
        <div className="info-time">{info.createTime}</div>
      </div>
    </div>
  );
}

export default NotifyInfo;
